<script setup>
import { onMounted, computed } from "vue"
import { useI18n } from 'vue-i18n'
import { $router } from '@/router'
import { useTitle } from '@/composables/title'
import { useMenu, useSubmenu } from '@/composables/menu'
import { useTranslate } from '@/composables/language'
import Accordion from '@/components/Accordion.vue'

const { t } = useTranslate();
const { tm, rt } = useI18n({ useScope: 'global' });

const sectionKeys = ["legal", "dataProtection", "compliance", "contact"];

const sections = computed(() => sectionKeys.map((key, idx) => {
  const raw = tm(`legalNotice.sections.${key}.lines`) || {};
  const lines = Object.keys(raw)
    .sort((a, b) => Number(a) - Number(b))
    .map(k => rt(raw[k]));
  return {
    key,
    title: t(`legalNotice.sections.${key}.title`),
    lines,
    defaultOpen: idx === 0, //Only expand the first section by default
  };
}));

onMounted(() => {
  useTitle(t("legalNotice.title"));
  useMenu(false);
  useSubmenu(false);
});

function goBack() {
  if (window.history.length > 1) {
    $router.back();
  }
  else {
    $router.push({ name: "Login" });
  }
}
</script>

<template>
  <div class="flex min-h-screen flex-1 flex-col px-6 py-12 lg:px-8 overflow-auto dark:bg-gray-900">

    <div class="flex-1 flex flex-col sm:mx-auto sm:w-full sm:max-w-2xl">

      <div class="mb-6 flex items-center gap-3">
        <Button type="secondary" @click="goBack">
          <i class="fa fa-arrow-left mr-2"></i>{{ t('generic.back') }}
        </Button>
        <h1 class="text-2xl font-bold text-gray-900 dark:text-gray-200">
          {{ t("legalNotice.title") }}
        </h1>
      </div>

      <div class="flex flex-col gap-3">
        <Accordion
          v-for="section in sections"
          :key="section.key"
          :title="section.title"
          :default-open="section.defaultOpen">
          <ul class="list-disc list-outside pl-5 text-sm text-gray-700 dark:text-gray-300 space-y-2">
            <li v-for="(line, i) in section.lines" :key="i">{{ line }}</li>
          </ul>
        </Accordion>
      </div>

    </div>

  </div>
</template>
